import { TFunction } from "i18next";

export function selectColor(value: number) {
  switch (value) {
    case 1:
      return "green";
    case 2:
      return "orange";
    case 3:
      return "red";
    default:
      return "red";
  }
}

export function answerTexts(value: number, t: TFunction<"ns1", undefined>) {
  switch (value) {
    case 1:
      return t("food.Approved");
    case 2:
      return t("food.Partial");
    case 3:
      return t("food.Not Approved");
    default:
      return "";
  }
}

//Multistate checkbox initial value transformer
export function answerMulticheckValues(answer: number) {
  switch (answer) {
    case 1:
      return "yes";
    case 2:
      return "partial";
    case 3:
      return "no";
    default:
      return "no";
  }
}
